var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.pageStatus == 0
        ? _c("FillOutStuInfo", {
            attrs: { baseArr: _vm.answerBaseList },
            on: {
              submitStuInfo: (data, evalData, meterList) =>
                _vm.setPageStatus(1, data, evalData, meterList),
            },
          })
        : _vm.pageStatus == 1
        ? _c("AnswerQuestion", {
            attrs: { baseArr: _vm.answerBaseList, queryObj: _vm.queryObj },
            on: {
              submitEvaluate: function ($event) {
                return _vm.setPageStatus(2)
              },
            },
          })
        : _c("SubmitAssessment", { attrs: { baseArr: _vm.answerBaseList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }